export default __webpack_public_path__ + "static/media/disabled-history.4abd50a8.svg";